import { createRequestTypes } from '../utils';

export const FETCH_MANDATE_PRODUCTS = createRequestTypes('mandateProduct/FETCH_MANDATE_PRODUCTS');
export const SAVE_MANDATE_PRODUCT = createRequestTypes('mandateProduct/SAVE_MANDATE_PRODUCT');
